export const ACCOUNTING_METHODS = {
  ACCRUAL: "ACCRUAL",
  CASH: "CASH",
  CASH_AND_ACCRUAL: "CASH_AND_ACCRUAL",
} as const;

export type ACCOUNTING_METHOD_TYPES = keyof typeof ACCOUNTING_METHODS;

export const ACCOUNTING_METHODS_OPTIONS = {
  [ACCOUNTING_METHODS.ACCRUAL]: "Accrual",
  [ACCOUNTING_METHODS.CASH]: "Cash",
  [ACCOUNTING_METHODS.CASH_AND_ACCRUAL]: "Cash & Accrual",
};
